export * from './full-layout';
export * from './simple-layout';



// WEBPACK FOOTER //
// C:/Users/bruna/Desktop/nuresp/src/app/containers/index.ts